import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../store';
import { setIsModalOpen, setModalContent, setModalContentProps, } from '../../../store/slices/global';
import Headline from '../../../ui/Headline';
import Button from '../../../ui/Button';
import ButtonsGroup from '../../../ui/ButtonsGroup';
import { MODAL_CONTENT } from '../../../app.config.vars/modalContent';
import { deleteAdminTask, sortTasks } from '../../../api/admin/tasks';
import { setTaskWasDeleted } from '../../../store/adminSlices/rallies';
import { useSelector } from 'react-redux';
import { selectClipboardTask, setClipboardTask } from '../../../store/adminSlices/clipboard';
const ConfirmDeleteTask = ({ rallyId, taskId, sortedTasks }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [deleteTaskStatus, setDeleteTaskStatus] = useState(null);
    const clipboardTask = useSelector(selectClipboardTask);
    const deleteTask = async () => {
        try {
            setDeleteTaskStatus('pending');
            await sortTasks(rallyId, sortedTasks?.map((task) => task.uid));
            await deleteAdminTask(taskId);
            dispatch(setTaskWasDeleted(true));
            setDeleteTaskStatus('success');
            dispatch(setIsModalOpen(false));
            dispatch(setModalContent(null));
            dispatch(setModalContentProps(null));
            if (String(clipboardTask?.id) === String(taskId)) {
                dispatch(setClipboardTask(null));
            }
        }
        catch (error) {
            dispatch(setIsModalOpen(true));
            dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
        }
    };
    return (_jsxs("div", { className: 'modal-content confirm-action', children: [_jsx("div", { className: "modal-content-title", children: _jsx(Headline, { title: t('admin.confirm_delete_task'), type: 'h1' }) }), _jsx("div", { className: "modal-content-button", children: _jsxs(ButtonsGroup, { justify: 'center', children: [_jsx(Button, { label: t('button.cancel'), onClick: () => {
                                dispatch(setIsModalOpen(false));
                                dispatch(setModalContent(null));
                            }, disabled: deleteTaskStatus === 'pending' || deleteTaskStatus === 'success' }), _jsx(Button, { variant: 'outlined', label: t('button.delete_task'), onClick: deleteTask, disabled: deleteTaskStatus === 'pending' || deleteTaskStatus === 'success' })] }) })] }));
};
export default ConfirmDeleteTask;
